const PAYMENT_STATUS = {
  0: 'PAYMENT_STATUS_0',
  1: 'PAYMENT_STATUS_1',
  2: 'PAYMENT_STATUS_2',
};

const PAYMENT_COLOR = {
  0: 'warning',
  1: 'partial',
  2: 'success',
};

export {
  PAYMENT_STATUS,
  PAYMENT_COLOR,
};
